import strings from "@/utils/strings";

export default [
	{
		title: strings.project.titles.accessGroups,
		route: { path: "groups", append: true },
		image: require("@/assets/access-groups.svg"),
		tile: true,
	},
];
